import "./party-style.css";
import {Swiper, SwiperSlide} from "swiper/react";
import {SlideContent} from "./SlideContent";
import {SliderConfig} from "./config/SliderConfig";
import {SliderProps} from "./SliderProps";
import {useState} from "react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import {ModalOrder} from "../modal/order/ModalOrder";
import axios from "axios";
import {toast} from "react-toastify";

export const Party = (slide: SliderProps) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSlide, setSelectedSlide] = useState<SliderProps["slide"][0] | null>(null);

    const openModal = (slideData: SliderProps["slide"][0]) => {
        setSelectedSlide(slideData);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedSlide(null); // Сброс выбранного слайда при закрытии
    };
    const successfully = () => {
        toast.success('Заявка успешно отправлена', {
            position:'bottom-right'
        })
    }

    const errorServer = (err: string) => {
        toast.warning(err, {
            position:'bottom-right'
        })
    }
    const handleSubmit = async (data: {name: string; phone: any; title: string}) => {
        try {
            const response = await axios.post('https://wow-holiday-server-miha823.amvera.io/api/order-call', data);
            if (response.data.success){
                successfully();
            }
        } catch (e) {
            console.error(e);
            errorServer('Заявка не отправлена. Повторите позже.')
        }
    }

    return (
        <>
        <section className="Party" id={'party'}>
            <div className="container">
                <h1 className="section__title">
                    Вечеринки и форматы
                </h1>
                <div className="slider-container">
                    <Swiper {...SliderConfig} className={'swiper'}>
                        {slide.slide.map((slide, index) => (
                            <>
                                <SwiperSlide key={index} className={'swiper'}>
                                    <img src={slide.image} alt={slide.alt} loading={"lazy"}/>
                                    <SlideContent slide={slide} onClick={() => openModal(slide)}/>
                                </SwiperSlide>
                            </>
                        ))}
                        <div className="swiper-button-prev"></div>
                        <div className="swiper-button-next"></div>
                    </Swiper>
                </div>
            </div>
        </section>
            <ModalOrder isOpen={isModalOpen} onClose={closeModal} onSubmit={handleSubmit} title={selectedSlide?.title || ''}/>
        </>
    );
}